import { supportingEvidence } from './supportingEvidence';

const normalized = value => String(value || '').replace(/\s+/g, ' ').trim();
const location = proof => ({
  file: proof.source_file || proof.paper_id || '',
  page: String(proof.source_fragment?.physical_page || proof.page_num || ''),
  region: JSON.stringify(proof.source_fragment?.bbox || null),
});
const sameEvidence = (left, right) => {
  const a = location(left), b = location(right);
  if (a.file !== b.file || (a.page && b.page && a.page !== b.page)) return false;
  if (a.region !== 'null' && b.region !== 'null' && a.region !== b.region) return false;
  return Boolean(left.evidence_id && left.evidence_id === right.evidence_id)
    || Boolean(normalized(left.evidence) && normalized(left.evidence) === normalized(right.evidence));
};
const richness = proof => Number(Boolean(proof.source_fragment)) * 4
  + Number(Boolean(proof.evidence_basis)) * 2 + Number(Boolean(proof.page_num));

// Include primary and explicitly attached proofs, excluding unrelated background passages.
export function uniqueEdgeEvidence(records) {
  const unique = [];
  const add = (proof, parent) => {
    if (!proof || (!proof.evidence && !proof.source_fragment)) return;
    const candidate = { ...proof, source_file: proof.source_file || proof.paper_id || parent.source_file || parent.paper_id };
    const match = unique.findIndex(existing => sameEvidence(existing, candidate));
    if (match < 0) unique.push(candidate);
    else if (richness(candidate) > richness(unique[match])) unique[match] = candidate;
  };
  for (const record of records) {
    add(record, record);
    for (const proof of [
      ...(record.statistics || []), ...(record.adjustments || []),
      ...supportingEvidence(record), ...(record.source_records || []),
    ]) add(proof, record);
  }
  return unique;
}
